import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { DOWNLOAD_QUERY_KEYS } from '../../shared/api/download/keys';
import { BatchDownloadData } from '../../types/batchDownload.types';

const useBatchDownload = (): { response: BatchDownloadData | undefined } => {
  const queryClient = useQueryClient();

  const fetcher = async (): Promise<BatchDownloadData | undefined> =>
    queryClient.getQueryData<BatchDownloadData>(
      DOWNLOAD_QUERY_KEYS.batchDownloadData()
    );

  const { data: response } = useSuspenseQuery({
    queryKey: DOWNLOAD_QUERY_KEYS.batchDownloadData(),
    queryFn: fetcher,
  });
  return { response };
};

export default useBatchDownload;
